export const lifecycleGate = {
label: {
draft: "Borrador",
open: "Abierto",
accepted: "Aceptado",
awaiting_assignee_response: "Esperando aceptación",
assignee_declined: "Rechazado por el asignado",
scheduled: "Programado",
in_progress: "En curso",
paused: "En pausa",
completion_submitted: "Pendiente de conformidad",
completion_rejected: "Corrección solicitada",
completion_verified: "Conforme",
awaiting_follow_on_approval: "Pendiente de aprobación",
cancelled: "Cancelado",
skipped: "Omitido",
},
shortLabel: {
draft: "Borrador",
open: "Abierto",
accepted: "Aceptado",
awaiting_assignee_response: "Esperando",
assignee_declined: "Rechazado",
scheduled: "Programado",
in_progress: "En curso",
paused: "En pausa",
completion_submitted: "Enviado",
completion_rejected: "Corrección",
completion_verified: "Conforme",
awaiting_follow_on_approval: "Aprobación",
cancelled: "Cancelado",
skipped: "Omitido",
},
nextActor: {
draft: "{{name}} finaliza el borrador",
open: "{{name}} acepta el trabajo",
awaiting_assignee_response: "{{name}} acepta o rechaza",
assignee_declined: "{{name}} reasigna el trabajo",
scheduled: "{{name}} inicia el trabajo",
in_progress: "{{name}} envía la finalización",
paused: "{{name}} reanuda cuando se resuelva el bloqueo",
completion_submitted: "{{name}} revisa la finalización",
completion_rejected: "{{name}} corrige el trabajo",
completion_verified: "El trabajo está cerrado",
awaiting_follow_on_approval: "{{name}} decide",
cancelled: "Sin más acciones",
skipped: "Sin más acciones",
},
nextActorYou: {
draft: "Tú finalizas el borrador",
open: "Tú aceptas el trabajo",
awaiting_assignee_response: "Tú aceptas o rechazas",
assignee_declined: "Tú reasignas el trabajo",
scheduled: "Tú inicias el trabajo",
in_progress: "Tú envías la finalización",
paused: "Tú reanudas cuando se resuelva el bloqueo",
completion_rejected: "Tú corriges el trabajo",
completion_submitted: "Tú revisas la finalización",
evidence_requested: "Añades las pruebas solicitadas y vuelves a enviar",
awaiting_follow_on_approval: "Tú apruebas o rechazas el seguimiento",
},
};
